import { DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApplicationModule, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardAreaModule } from './dashboard-area/dashboard-area.module';
import { AlertService } from './dashboard-area/shared/alert.service';
import { ExportPdfButtonService } from './dashboard-area/shared/export-pdf-button/export-pdf-button.service';
import { WorkSessionService } from './dashboard-area/shared/work-session.service';
import { ThingSimService } from './dashboard-area/thing/thing-sim/thing-sim.service';
import { ActionContextService } from './service/action-context.service';
import { ActionDefinitionTypeService } from './service/action-definition-type.service';
import { ActionDefinitionService } from './service/action-definition.service';
import { ActionDiscardReasonService } from './service/action-discard-reason.service';
import { ActionIssueTypeService } from './service/action-issue-type.service';
import { ActionStatusAttachmentService } from './service/action-status-attachment.service';
import { AddButtonContextService } from './service/add-button-context.service';
import { AlertDefinitionService } from './service/alert-definition.service';
import { AlgorithmService } from './service/algorithm.service';
import { ApiKeyService } from './service/api-key.service';
import { AppService } from './service/app.service';
import { authInterceptorProviders } from './service/auth.interceptor';
import { AuthenticationService } from './service/authentication.service';
import { BreadcrumbService } from './service/breadcrumb.service';
import { ColorManagerService } from './service/color-manager.service';
import { CommandService } from './service/command.service';
import { ContextService } from './service/context.service';
import { ControlBarService } from './service/control-bar.service';
import { CountryService } from './service/country.service';
import { CustomLabelService } from './service/custom-label.service';
import { CustomPropertyService } from './service/custom-property.service';
import { CustomerTreeService } from './service/customer-tree.service';
import { DataExportConfigurationService } from './service/data-export-configuration.service';
import { DataSharingTokenService } from './service/data-sharing-token.service';
import { DataService } from './service/data.service';
import { DateRangeService } from './service/date-range.service';
import { DefaultPropertySettingsService } from './service/default-property-settings.service';
import { DigitalServiceService } from './service/digital-service.service';
import { DownloadService } from './service/download.service';
import { ExportContextService } from './service/export-context.service';
import { ExternalApiClientService } from './service/external-api-client.service';
import { ExternalAppUtilsService } from './service/external-app-utils.service';
import { ExternalCatalogService } from './service/external-catalog.service';
import { ExternalComponentUtilsService } from './service/external-component-utils.service';
import { FieldService } from './service/field.service';
import { FilterService } from './service/filter.service';
import { FlatTreeService } from './service/flat-tree.service';
import { FormCheckerService } from './service/form-checker.service';
import { HttpService } from './service/http.service';
import { IncrementService } from './service/increment.service';
import { IndexedDBService } from './service/indexeddb.service';
import { InternalHttpService } from './service/internal-http.service';
import { ListSnackbarService } from './service/list-snackbar.service';
import { localNavigationInterceptorProviders } from './service/local-navigation.interceptor';
import { LocalStorageService } from './service/local-storage.service';
import { LocalizationService } from './service/localization.service';
import { LogoutService } from './service/logout.service';
import { MetricService } from './service/metric.service';
import { NavigationService } from './service/navigation.service';
import { NetworkDataService } from './service/network-data.service';
import { NetworkMetricService } from './service/network-metric.service';
import { OfflineNavigationService } from './service/offline-navigation.service';
import { ParameterService } from './service/parameter.service';
import { PatternValidationService } from './service/patternValidation.service';
import { PermissionService } from './service/permission.service';
import { ProblemService } from './service/problem.service';
import { ProductModelCategoryService } from './service/product-model-category.service';
import { ProductModelPartService } from './service/product-model-part.service';
import { ProductModelSparePartDefinitionReferenceService } from './service/product-model-spare-part-definition-reference.service';
import { ProductModelService } from './service/product-model.service';
import { PropertyService } from './service/property.service';
import { QuickHistoryDialogService } from './service/quick-history-dialog.service';
import { RefresherWidgetService } from './service/refresher-widget.service';
import { ServiceLevelService } from './service/service-level.service';
import { SocketService } from './service/socket.service';
import { StatisticService } from './service/statistic.service';
import { StoreCartService } from './service/store-cart.service';
import { StoreOrderProviderService } from './service/store-order-provider.service';
import { StoreOrderService } from './service/store-order.service';
import { StyleConfigurationService } from './service/style-configuration.service';
import { SubscriptionSetService } from './service/subscription-set.service';
import { SubscriptionService } from './service/subscription.service';
import { ThingActionOverrideService } from './service/thing-action-override.service';
import { ThingContextService } from './service/thing-context.service';
import { ThingDefinitionService } from './service/thing-definition.service';
import { ThingService } from './service/thing.service';
import { TicketService } from './service/ticket.service';
import { TimezoneService } from './service/timezone.service';
import { TitleService } from './service/title.service';
import { TopBarExportContextService } from './service/top-bar-export-context.service';
import { TreeNodeService } from './service/tree-node.service';
import { TreeService } from './service/tree.service';
import { UiService } from './service/ui.service';
import { UserActionStatusService } from './service/user-action-status.service';
import { UserCustomerService } from './service/user-customer.service';
import { UserEventService } from './service/user-event.service';
import { UserLocationService } from './service/user-location.service';
import { UserPartnerService } from './service/user-partner.service';
import { UserThingService } from './service/user-thing.service';
import { UserTypeService } from './service/user-type.service';
import { UserValuesService } from './service/user-values.service';
import { ViewService } from './service/view.service';
import { WearStatusService } from './service/wear-status.service';
import { WidgetRegistrationService } from './service/widget-registration.service';
import { WorkOrderService } from './service/work-order.service';
import { WorkSessionDefinitionService } from './service/work-session-definition.service';
import { AlertSeverityPipe, BulkUpdateLocalizationPipe, CapitalizePipe, DatetimeFormatterPipe, DefaultCloudStatusPipe, DefaultConnectionStatusPipe, DefaultServiceLevelPipe, FormErrorPipe, LoaderPipe, LocalizationPipe, TagLocalizationPipe } from './shared/pipe';
import { ActionStatePipe } from './shared/pipe/action-state.pipe';
import { AddOnLabelPipe } from './shared/pipe/add-on-label.pipe';
import { ByteFormatterPipe } from './shared/pipe/byte-formatter.pipe';
import { CustomLabelPipe } from './shared/pipe/custom-label.pipe';
import { DataExportStatePipe } from './shared/pipe/data-export-state.pipe';
import { DataImportStatePipe } from './shared/pipe/data-import-state.pipe';
import { DefaultSimSessionStatusPipe } from './shared/pipe/default-sim-session-status.pipe';
import { EventSeverityPipe } from './shared/pipe/event-severity.pipe';
import { FirmwareUpdateStatusPipe } from './shared/pipe/firmware-update-status.pipe';
import { PartnerStatusPipe } from './shared/pipe/partner-status.pipe';
import { PlanLabelPipe } from './shared/pipe/plan-label.pipe';
import { ServitlyBadgePipe } from './shared/pipe/servitly-badge.pipe';
import { StatusTagPipe } from './shared/pipe/status-tag.pipe';
import { UnderscoreRemoverPipe } from './shared/pipe/underscore-remover.pipe';
import { TagService } from './shared/tags/tag.service';
import { UserService } from './shared/users/user.service';
import { StyleLoaderComponent } from './style-loader/style-loader.component';
import { FormUtility, HttpUtility, ObjectUtility, Sorting } from './utility';
import { DataAggregationUtility } from './utility/data-aggregation-utility';
import { SnackbarService } from './widget/shared/snackbar.service';
import { SparePartDefinitionService } from './widget/shared/spare-part-definition.service';
import { WidgetPrintResizeCoordinatorService } from './widget/shared/widget-print-resize-coordinator.service';

library.add(fas, far, fab);

@NgModule({
    imports: [
        ApplicationModule,
        BrowserAnimationsModule,
        FontAwesomeModule,
        HttpClientModule,
        DashboardAreaModule.forRoot(),
        AppRoutingModule
    ],
    declarations: [
        StyleLoaderComponent,
        AppComponent
    ],
    exports: [],
    providers: [
        authInterceptorProviders,
        localNavigationInterceptorProviders,
        HttpUtility,
        ObjectUtility,
        Title,
        FormUtility,
        Sorting,
        AppService,
        AuthenticationService,
        BreadcrumbService,
        ContextService,
        CustomLabelService,
        CustomPropertyService,
        CustomerTreeService,
        DataService,
        FieldService,
        FormCheckerService,
        HttpService,
        InternalHttpService,
        LocalStorageService,
        LocalizationService,
        MetricService,
        NavigationService,
        SocketService,
        ThingContextService,
        ThingService,
        CountryService,
        TimezoneService,
        TitleService,
        TreeService,
        UserTypeService,
        ViewService,
        DownloadService,
        RefresherWidgetService,
        StatisticService,
        PropertyService,
        ExternalAppUtilsService,
        ExternalApiClientService,
        ExternalComponentUtilsService,
        LocalizationPipe,
        LoaderPipe,
        DefaultServiceLevelPipe,
        PlanLabelPipe,
        AddOnLabelPipe,
        BulkUpdateLocalizationPipe,
        FormErrorPipe,
        TagLocalizationPipe,
        UnderscoreRemoverPipe,
        SubscriptionService,
        CommandService,
        ParameterService,
        NetworkMetricService,
        NetworkDataService,
        ActionContextService,
        UserCustomerService,
        UserLocationService,
        UserPartnerService,
        UserThingService,
        WidgetRegistrationService,
        WidgetPrintResizeCoordinatorService,
        UiService,
        DateRangeService,
        UserValuesService,
        IncrementService,
        ThingSimService,
        DefaultPropertySettingsService,
        PatternValidationService,
        DecimalPipe,
        ByteFormatterPipe,
        DefaultSimSessionStatusPipe,
        TagService,
        UserService,
        DatetimeFormatterPipe,
        AlertSeverityPipe,
        EventSeverityPipe,
        DefaultConnectionStatusPipe,
        DefaultCloudStatusPipe,
        ControlBarService,
        AlertService,
        TopBarExportContextService,
        ExportContextService,
        QuickHistoryDialogService,
        LogoutService,
        ExportPdfButtonService,
        WorkSessionService,
        FilterService,
        ApiKeyService,
        ThingDefinitionService,
        AlertDefinitionService,
        ServiceLevelService,
        WorkSessionDefinitionService,
        PermissionService,
        CapitalizePipe,
        DataExportConfigurationService,
        FlatTreeService,
        ProductModelService,
        ProductModelPartService,
        StoreCartService,
        StoreOrderService,
        TreeNodeService,
        SparePartDefinitionService,
        StoreOrderProviderService,
        ProductModelSparePartDefinitionReferenceService,
        WearStatusService,
        UserActionStatusService,
        AddButtonContextService,
        ProductModelCategoryService,
        ExternalCatalogService,
        SnackbarService,
        FirmwareUpdateStatusPipe,
        SubscriptionSetService,
        ActionDefinitionService,
        ActionDefinitionTypeService,
        ActionStatePipe,
        StatusTagPipe,
        ActionDiscardReasonService,
        DataExportStatePipe,
        ActionIssueTypeService,
        DataImportStatePipe,
        IndexedDBService,
        ColorManagerService,
        ThingActionOverrideService,
        ActionStatusAttachmentService,
        OfflineNavigationService,
        UserEventService,
        DigitalServiceService,
        ProblemService,
        PartnerStatusPipe,
        ServitlyBadgePipe,
        DataAggregationUtility,
        TicketService,
        AlgorithmService,
        DataSharingTokenService,
        WorkOrderService,
        StyleConfigurationService,
        CustomLabelPipe,
        ListSnackbarService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
